import { graphql } from "react-relay"

export const chTimeWindowFragment = graphql`
  fragment chTimeWindowFragment on ch_TimeWindow
  @relay(plural: true)
  @argumentDefinitions(language: { type: "String!" }) {
    __typename
    createdBy
    createdAt
    updatedBy
    updatedAt
    errorCorrection
    referenceDate
    referredByExternalCareProviderId
    alternativeTriage
    referralReason
    referralToCareProvider {
      id
      businessName
      title
      firstName
      lastName
      groupName(language: $language)
      careProviderSpecialtyTranslations(language: $language) {
        name
      }
      officialLanguageLookupTranslations(language: $language) {
        isoLanguageName
      }
      careProviderGroup {
        groupType
      }
      country {
        countryName(language: $language)
      }
      creditorCodeRegister
      isMedgatePartnerNetworkMember
      isTakesNewPatients
      phoneNumber
      email
      website
      globalLocationNumber
      countryCode
      city
      postalCode
      streetAddress
      additionalAddress
      relationType
      relationBusinessName
      relationFirstName
      relationLastName
      relationTitle
      billsVia {
        businessName
        firstName
        lastName
        title
      }
      network {
        name
      }
      detailedSchedule {
        day
        workingType
        periods {
          start
          end
        }
      }
    }
    dateFrom
    dateTo
    id
    internalComment
    patientId
    referralToCareProviderId
    referralToDoctorName
    referredBy
    progressNoteId
    involvesPreventionProgram
    alternativeTriageEntry {
      id
      phoneNumber
      reason
    }
  }
`
